import React, { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import pimg1 from '../../images/clients/client_logo_1.png'
import pimg2 from '../../images/clients/client_logo_2.png'
import pimg3 from '../../images/clients/client_logo_3.png'
import pimg4 from '../../images/clients/client_logo_4.jpg'
import pimg5 from '../../images/clients/client_logo_5.jpg'
import pimg6 from '../../images/clients/client_logo_6.jpg'
import pimg7 from '../../images/clients/client_logo_7.jpg'
import pimg8 from '../../images/clients/client_logo_8.jpg'
import pimg9 from '../../images/clients/client_logo_9.jpg'
import pimg10 from '../../images/clients/client_logo_10.png'
import pimg11 from '../../images/clients/client_logo_11.jpg'
import pimg12 from '../../images/clients/client_logo_12.jpg'

const partners = [
    { pImg: pimg1, brand: 'HP' },
    { pImg: pimg2, brand: 'APC' },
    { pImg: pimg3, brand: 'Oracle' },
    { pImg: pimg4, brand: 'Microsoft' },
    { pImg: pimg5, brand: 'Asenware' },
    { pImg: pimg6, brand: 'Datacard' },
    { pImg: pimg7, brand: 'Ortea' },
    { pImg: pimg8, brand: 'Dell' },
    { pImg: pimg9, brand: 'Tyco Fire Safety' },
    { pImg: pimg10, brand: 'AVTECH' },
    { pImg: pimg11, brand: 'ESET' },
    { pImg: pimg12, brand: 'HP' },
]

var settings = {
    dots: false,
    infinite: true,
    speed: 3000,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    arrows: false,

    responsive: [
        {
            breakpoint: 1025,
            settings: {
                slidesToShow: 7,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 450,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 350,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};



const PartnerSection = (props) => {
    const sliderRef = useRef(null);

    const handleMouseEnter = () => {
        if (sliderRef.current) {
            sliderRef.current.slickPause();
        }
    };

    const handleMouseLeave = () => {
        if (sliderRef.current) {
            sliderRef.current.slickPlay();
        }
    };

    const handleBrandClick = (brand) => {
        // Open shop with brand filter
        window.open(`https://store.kemstec.com/shop?brand=${encodeURIComponent(brand)}`, '_blank');
    };

    return (
        <div 
            className="client_logo_carousel"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{ cursor: 'pointer' }}
        >
            <Slider ref={sliderRef} {...settings}>
                {partners.map((partner, pitem) => (
                    <div 
                        className="client_logo_item" 
                        key={pitem}
                        onClick={() => handleBrandClick(partner.brand)}
                    >
                        <img 
                            src={partner.pImg} 
                            alt={`${partner.brand} Logo`} 
                            style={{ cursor: 'pointer' }}
                        />
                    </div>
                ))}
            </Slider>
        </div>
    );
}

export default PartnerSection;